<template>
  <ul id="sidenav" class="list-unstyled py-3">
    <li class="base">
      <router-link :to="'/' + subdomain + '/terms-of-use'">
        <img
          src="@/assets/images/arrow-ios-right.svg"
          width="24px"
          height="24px"
          alt="Arrow iOS Right"
        />
        Terms of Use
      </router-link>
    </li>
    <li class="base">
      <router-link :to="'/' + subdomain + '/privacy-policy'">
        <img
          src="@/assets/images/arrow-ios-right.svg"
          width="24px"
          height="24px"
          style="position: relative; "
          alt="Arrow iOS Right"
        />
        {{ subdomain === 'ucoin' ? 'FAQ' : 'Privacy Policy' }}
      </router-link>
    </li>
  </ul>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      activeClass: "active",
      sampleClass: {
        backgroundColor: 'red',
        color: 'blue'
      }
    };
  },
  computed: {
    ...mapState("merchant", {
      subdomain: state => state.subdomain
    }),
    currentPage() {
      return this.$route.path;
    }
  }
};
</script>

<style lang="scss" scoped>
#sidenav {
  .base {
    font-style: normal;
    font-size: 18px;
    line-height: 23px;
    a {
      display: block;
      padding: 20px;
      img {
        margin-right: 12px;
        position: relative;
        top: -1px;
      }
      color: #49545c;
    }
    & > ul {
      padding-left: 53px;
      padding-top: 12px;
    }
  }
  .nested {
    font-style: normal;
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 20px;
    a {
      color: #49545c;
    }
  }
  .router-link-active {
    color: #ff8a00 !important;
    background: #fcf8f8;
    @extend .mainFontBold;
  }
}
</style>
